(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/map-play.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/map-play.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useEffect,
  useMemo,
  useState
} = React;
const {
  CONSTANTS
} = svs.lyckoplatsen.components.shared_constants;
const {
  getPlayMapHandler
} = svs.lyckoplatsen.components.shared_map;
const {
  charityAtom,
  activeCharitiesAtom
} = svs.lyckoplatsen.shared_charity.jotai.atoms;
const {
  isMovingAtom,
  isCenteredAtom,
  mapZoomLevelAtom
} = svs.lyckoplatsen.shared_map.atoms;
const {
  filterCharityById
} = svs.lyckoplatsen.page_play.utils;
const {
  showWrongCharityDialog
} = svs.lyckoplatsen.components.shared_charity.utils;
const logger = svs.lyckoplatsen.logger;
const {
  useSetAtom,
  useAtom,
  useAtomValue
} = jotai;
const {
  useIsUserAfk
} = svs.lyckoplatsen.components.page_play.react.hooks;
const {
  pinLocationAtom,
  pinLocationTypeAtom,
  disableCenterMapButtonAtom,
  mapLocationAtom,
  locationConfirmedAtom,
  shouldShowPinAtom,
  isProlonginationAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  mapErrorDialog
} = svs.lyckoplatsen.shared_map.utils;
const nodeId = 'mapPlay';
const MapPlay = () => {
  const mapHandlerPlay = useMemo(() => getPlayMapHandler(), []);
  const [pinLocation, setPinLocation] = useAtom(pinLocationAtom);
  const [mapLocation, setMapLocation] = useAtom(mapLocationAtom);
  const [isCentered, setIsCentered] = useAtom(isCenteredAtom);
  const [shouldShowPin, setShouldShowPin] = useAtom(shouldShowPinAtom);
  const [pinLocationType, setPinLocationType] = useAtom(pinLocationTypeAtom);
  const locationConfirmed = useAtomValue(locationConfirmedAtom);
  const isProlongination = useAtomValue(isProlonginationAtom);
  const setDisableCenterMapButton = useSetAtom(disableCenterMapButtonAtom);
  const setMapZoomLevel = useSetAtom(mapZoomLevelAtom);
  const setIsMoving = useSetAtom(isMovingAtom);
  const charity = useAtomValue(charityAtom);
  const setCharity = useSetAtom(charityAtom);
  const activeCharities = useAtomValue(activeCharitiesAtom);
  const [charityChecked, setCharityChecked] = useState(false);
  const trackPinPlacedByClick = () => {
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action: 'Sök manuellt',
      opt_label: CONSTANTS.LOCATION_TYPES.OTHER
    });
  };
  useEffect(() => {
    var _svs$utils$paramHandl;
    const paramCharityId = (_svs$utils$paramHandl = svs.utils.paramHandler.get({
      key: 'charityId'
    })) === null || _svs$utils$paramHandl === void 0 ? void 0 : _svs$utils$paramHandl.value;
    if (paramCharityId) {
      const charity = filterCharityById(activeCharities, parseInt(paramCharityId, 10));
      if (charity) {
        setCharity(charity);
      } else {
        setCharity(false);
        showWrongCharityDialog();
        logger.info("Wrong Param, CharityId dont exists, charityId: ".concat(paramCharityId));
      }
      svs.utils.paramHandler.remove({
        key: 'charityId'
      });
    }
    setCharityChecked(true);
  }, []);

  useEffect(() => {
    let map = null;
    const mapOptions = {
      nodeId,
      maxZoom: 18,
      maxBounds: [[72.1, -5.5], [47.1, 39.5]],
      location: pinLocation,
      showErrorOverlay: false,
      zoomSnap: 0.25,
      touchZoom: true,
      errorCallback: mapErrorDialog,
      zoomAnimation: true,
      fadeAnimation: true,
      type: 'play',
      geoJson: true,
      charity: Boolean(charity === null || charity === void 0 ? void 0 : charity.charityId)
    };
    const eventHandlers = {
      mapClicked: function () {
        var _map;
        let newLocation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          lat: null,
          lng: null
        };
        if (((_map = map) === null || _map === void 0 ? void 0 : _map.getZoom()) >= CONSTANTS.PLACE_PIN_ZOOM_LEVEL) {
          setPinLocation(newLocation);
          newLocation.lat && trackPinPlacedByClick();
        } else {
          var _map2;
          let zoomLevel = CONSTANTS.PLACE_PIN_ZOOM_LEVEL;
          if (((_map2 = map) === null || _map2 === void 0 ? void 0 : _map2.getZoom()) < CONSTANTS.FIRST_ZOOM_LEVEL) {
            zoomLevel = CONSTANTS.FIRST_ZOOM_LEVEL;
          }
          setMapLocation(_objectSpread(_objectSpread({}, newLocation), {}, {
            zoomLevel
          }));
          if (!newLocation.lat) {
            setPinLocation(newLocation);
          }
        }
        setPinLocationType(CONSTANTS.LOCATION_TYPES.OTHER);
      },
      disableCenterMapButton: bool => {
        setDisableCenterMapButton(bool);
      },
      showPin: bool => {
        setShouldShowPin(bool);
      },
      updateIsMoving: isMoving => {
        setIsMoving(isMoving);
      },
      updateZoomLevel: zoomLevel => {
        setMapZoomLevel(zoomLevel);
      },
      showMapErrorDialog: () => {
        mapErrorDialog();
      }
    };
    if (charityChecked) {
      map = mapHandlerPlay.createMap(mapOptions, eventHandlers);
    }
    return () => mapHandlerPlay.removeMap();
  }, [charityChecked]);

  useIsUserAfk();

  useEffect(() => {
    if (pinLocation.lat && charityChecked) {
      mapHandlerPlay.placePin({
        location: pinLocation,
        animateFlyTo: !isProlongination || shouldShowPin
      });
      mapHandlerPlay.focusMap();
    }
  }, [pinLocation, charityChecked]);

  useEffect(() => {
    if (shouldShowPin && charityChecked) {
      mapHandlerPlay.addPopup(pinLocation, charity, pinLocationType);
    }
  }, [shouldShowPin, charity, charityChecked]);

  useEffect(() => {
    if (!locationConfirmed && !pinLocation.lat) {
      mapHandlerPlay.removePin();
    }
  }, [locationConfirmed, pinLocation]);

  useEffect(() => {
    if (mapLocation.lat && mapLocation.lng) {
      mapHandlerPlay.moveTo(mapLocation);
    }
  }, [mapLocation]);

  useEffect(() => {
    if (!isCentered) {
      mapHandlerPlay === null || mapHandlerPlay === void 0 || mapHandlerPlay.centerMap();
      setIsCentered(true);
    }
  }, [isCentered]);
  return React.createElement("div", {
    className: "animated-body"
  }, React.createElement("div", {
    id: nodeId,
    className: "lp-map-play",
    tabIndex: "0"
  }));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  MapPlay
});

 })(window);